import { render, staticRenderFns } from "./SupplierSales.vue?vue&type=template&id=79394d2a&scoped=true"
import script from "./SupplierSales.vue?vue&type=script&lang=js"
export * from "./SupplierSales.vue?vue&type=script&lang=js"
import style0 from "./SupplierSales.vue?vue&type=style&index=0&id=79394d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79394d2a",
  null
  
)

export default component.exports